/* eslint-disable no-undef */

import Oidc from 'oidc-client';

const config = {
	client_id: globalConfig.authentication.clientId,
	redirect_uri: `${globalConfig.authentication.redirect_uri}/callback.html`,
	authority: globalConfig.authentication.authority,
	debug: globalConfig.authentication.debug,
	response_type: globalConfig.authentication.response_type,
	post_logout_redirect_uri: globalConfig.authentication.logout_uri,
	userStore: new Oidc.WebStorageStateStore(),
	scope: globalConfig.authentication.scope,
	resource: globalConfig.authentication.resource,
	automaticSilentRenew: false,
};

const oidcManager = new Oidc.UserManager(config);

oidcManager.events.addAccessTokenExpired((e) => {
	oidcManager.signinRedirect();
});

export default oidcManager;
